import React from 'react'
import styled from 'styled-components'
import './info.css'
import { Tooltip } from 'antd'

const View = styled.div``
const Text = styled.div`font-size: 10px; font-weight: 600;`
const Note = styled.div`font-size: 12px; font-weight: normal;`

export default class InfoContainer extends React.PureComponent {

  _renderView() {
    const { value, status, color, textColor } = this.props
    return (
      <View className='d-container'>
        <View className='d-header'>
        <Text className='d-text'>{this.props.title}</Text>
        </View>
        <View className='d-content' style={{ backgroundColor: color || '#00e400', color: textColor }}>
          {
            this.props.TextFirst ? <Text style={{ fontSize: 20 }}>{value}</Text> : <Note>{status}</Note>
          }
          {
            this.props.TextFirst ? <Note>{status}</Note> : <Text style={{ fontSize: 20 }}>{value}</Text>
          }
        </View>
      </View>
    )
  }

  render() {
    return this.props.TextFirst ? <Tooltip title={this.props.note} placement='right'>{this._renderView()}</Tooltip> : this._renderView()
  }
}